import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Alert } from '@one-thd/sui-atomic-components';

const errorMsgs = {
  missingContent: 'We are unable to save your estimate with your selected carpet at this time.  Please',
  invalidContent: 'The carpet you selected is unavailable and your estimate cannot be saved at this time. Please'
};

const ErrorOnPage = ({ errorCode }) => {
  // TODO: this should be dynamic once navParam is implemented
  const PLPUrl = 'https://www.homedepot.com/b/Flooring-Carpet-Installed-Carpet/N-5yc1vZ2fkpcfz';
  return (
    <Alert status="error">
      <Typography paragraph>{errorMsgs[errorCode]}&nbsp;
        <a href={`${PLPUrl}`} target="_blank" rel="noreferrer" style={{ textDecoration: 'underline' }}>
          choose a different carpet
        </a>.
      </Typography>
    </Alert>
  );
};

ErrorOnPage.propTypes = {
  errorCode: PropTypes.string.isRequired,
};

export default ErrorOnPage;